"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.reducer = exports.initialState = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _userInterfaceNotifications = require("./userInterfaceNotifications.actions");

var initialState = {
  notifications: []
};
exports.initialState = initialState;
var initialStoreDeepCopy = JSON.parse(JSON.stringify(initialState));

var reducer = function reducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case _userInterfaceNotifications.types.ADD_NOTIFICATION_AFTER:
      {
        return (0, _extends2["default"])({}, state, {
          notifications: [].concat(state.notifications, [action.payload])
        });
      }

    case _userInterfaceNotifications.types.REMOVE_NOTIFICATION:
      {
        var id = action.payload.id;
        return (0, _extends2["default"])({}, state, {
          notifications: state.notifications.filter(function (n) {
            return n.id !== id;
          })
        });
      }

    case _userInterfaceNotifications.types.RESET_STORE:
      return initialStoreDeepCopy;

    default:
      return state;
  }
};

exports.reducer = reducer;